import React from 'react';
import {
    withStyles,
    Typography, 
    Grid, 
    ButtonBase,
    Divider,
} from '../../material-ui';
import MBack from '../view/MBack';
import Apis from '../../network/Apis';
import MSnackbar from '../view/MSnackbar';
import AppUtils from '../../control/apputlis';

class Feedback extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            message: '',
            phonemsg: '',
        };
    }

    componentDidMount() {
        AppUtils.YMPush('MAIN', 'Feedback');
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    _onSureClick = () => {
        let message = this.state.message;
        let pmsg = this.state.phonemsg;
        if (message == '') {
            this.toast.show('请输入反馈内容.');
            return;
        }

        if (pmsg == '') {
            this.toast.show('请输入联系方式.');
            return;
        }

        this._onFeed();
    }

    _onFeed = async () => {
        let result = await Apis.encryptionCustomerBack(this.state.message, this.state.phonemsg);
        console.log('_onFeed', result);
        if (result.code == 200) {
            this.toast.show("反馈意见提交成功~");
        }
        else {
            this.toast.show(result.msg);
        }
    }

    render() {
        const { message, phonemsg } = this.state;
        const { classes } = this.props;
        return (
            <MBack title='意见反馈'>
                <Grid container direction='row' style={{ height: 16 }}></Grid>
                <Grid container direction='row' style={{
                    width: '100%',
                    height: 120,
                    backgroundColor: '#fff',
                    justifyContent: 'center',
                }}>
                    <textarea
                        onChange={event => this.setState({ message: event.target.value })}
                        value={message}
                        className={classes.textfield}
                        maxLength={200}
                        placeholder="请留下您的问题或建议..." />

                </Grid>
                <Grid container justifyContent='flex-end' className={classes.tipsBox}>
                    <Typography className={classes.textTip}> {200 - message.length} </Typography>
                </Grid>
                <Grid container justifyContent='center'>
                    <Divider light style={{ background: '#E2E2E2', width: '94%', justifyContent: 'center' }} />
                </Grid>
                <Grid container justifyContent='flex-start'>
                    <Typography className={classes.tittle}> 联系方式 </Typography>
                    <input
                        onChange={event => this.setState({ phonemsg: event.target.value })}
                        value={phonemsg}
                        className={classes.phonefield}
                        placeholder="比如QQ、微信、手机号" />
                </Grid>
                <Grid container justifyContent='center'>
                    <Divider light style={{ background: '#E2E2E2', width: '94%', justifyContent: 'center' }} />
                </Grid>
                <Grid container justifyContent='center' >
                    <ButtonBase
                        className={classes.sureBtn}
                        onClick={() => this._onSureClick()}
                    >确 定</ButtonBase>
                </Grid>
                <MSnackbar ref={(ref) => { this.toast = ref }} />
            </MBack >
        );
    }
}
export default withStyles((theme) => ({
    textTip: {
        color: '#878787',
        fontSize: 10,
    },
    textfield: {
        fontSize: 14,
        height: 112,
        borderRadius: 5,
        width: '90%',
        border: 'none',
        outline: 'none',
    },
    tipsBox: {
        padding: theme.spacing(0, 2.5),
    },
    tittle: {
        color: '#0D0D0D',
        padding: theme.spacing(1, 2),
        fontSize: 14,
    },
    phonefield: {
        fontSize: 12,
        borderRadius: 5,
        width: '65%',
        border: 'none',
        outline: 'none',
    },
    sureBtn: {
        background: '#007AFF',
        borderRadius: 22.5,
        color: 'white',
        height: 45,
        width: "80%",
        margin: theme.spacing(5, 0, 2, 0),
        fontSize: 14,
        fontWeight: theme.typography.fontWeightBold,
    },
}))(Feedback);
